import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';

const MacPlatforms = [
  'iPad',
  'iPad Simulator',
  'Macintosh',
  'MacIntel',
  'MacPPC',
  'Mac68K'
];

// keyevents without ctrl
export const useKeyPressBase = (keys, callback, node = null) => {
  // implement the callback ref pattern
  const callbackRef = useRef(callback);
  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  // handle what happens on key press
  const handleKeyPress = useCallback(
    event => {
      if (
        // Avoid when an input element is in focus
        document.activeElement.tagName !== 'INPUT' &&
        keys.some(key => event.keyCode === key)
      ) {
        event.preventDefault();
        callbackRef.current(event);
      }
    },
    [keys]
  );

  useEffect(() => {
    // target is either the provided node or the document
    const targetNode = node ?? document;
    // attach the event listener
    targetNode && targetNode.addEventListener('keydown', handleKeyPress);

    // remove the event listener
    return () =>
      targetNode && targetNode.removeEventListener('keydown', handleKeyPress);
  }, [handleKeyPress, node]);
};

export const useKeyPress = (keys, callback, node = null) => {
  // implement the callback ref pattern
  const callbackRef = useRef(callback);
  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  // handle what happens on key press
  const handleKeyPress = useCallback(
    event => {
      if (
        // Avoid when an input element is in focus
        document.activeElement.tagName !== 'INPUT' &&
        keys.some(key => event.key === key) &&
        (MacPlatforms.includes(window.navigator.platform)
          ? event.metaKey === true
          : event.ctrlKey === true)
      ) {
        event.preventDefault();
        callbackRef.current(event);
      }
    },
    [keys]
  );

  useEffect(() => {
    // target is either the provided node or the document
    const targetNode = node ?? document;
    // attach the event listener
    targetNode && targetNode.addEventListener('keydown', handleKeyPress);

    // remove the event listener
    return () =>
      targetNode && targetNode.removeEventListener('keydown', handleKeyPress);
  }, [handleKeyPress, node]);
};
// export default useKeyPress;
